import { useTranslation } from "react-i18next";
import { VisibilityMode } from "../../../../types";
import FaCogSvg from "./FaCogSvg";

export default function ToolsMenuButton({
	toggleMenu,
	visibilityMode,
}: {
	toggleMenu: () => void;
	visibilityMode: VisibilityMode | null;
}) {
	const { t } = useTranslation();

	return (
		<button
			onClick={toggleMenu}
			className={`
                block rounded-full active:scale-90 transition-opacity duration-1200 cursor-pointer 
                ${
                    visibilityMode !== VisibilityMode.Normal
                        ? `md:[filter:drop-shadow(0.1px_0.05px_2px_rgb(255_255_255))] lg:[filter:drop-shadow(0.1px_0.05px_3px_rgb(255_255_255))] 2xl:[filter:drop-shadow(0.1px_0.05px_0.2vw_rgb(255_255_255))]`
                        : ""
                }
            `}
			title={t("navBarItems.toolsMenu.title")}
			aria-label={t("navBarItems.toolsMenu.title")}
		>
			<FaCogSvg ariaLabel={t("navBarItems.toolsMenu.title")} />
		</button>
	);
}